// extracted by mini-css-extract-plugin
module.exports = {"banner":"S_dq","icon":"S_cj","title":"S_J","text":"S_bL","button":"S_bH"};